import classNames from 'classnames';
import React from 'react';
import { CardType } from '../../TimetableVersion/graphql/types';
import styles from './GridCard.module.scss';

type PreviewGridCardProps = {
  card: CardType;
  width: string;
  height: string;
  top: string;
  left: string;
  background: string;
  textColor: string;
};

/**
 * Read-only ghost card for the running solver's live preview. Renders only the visual
 * (subject label + position) using the same CSS the persisted card already carries; it has
 * no interaction handlers and `pointer-events: none`, so clicks pass through to the grid.
 */
export const PreviewGridCard = ({ card, top, width, background, height, textColor, left }: PreviewGridCardProps) => {
  const title = [
    card.subject?.name,
    card.teachers.map((t) => t.shortName).join(', '),
    card.classes.map((c) => c.shortName).join(', '),
  ]
    .filter(Boolean)
    .join(' | ');

  return (
    <div
      title={title}
      className={classNames(styles['grid-card'], styles.preview)}
      style={
        {
          '--grid-card-bg': background,
          '--grid-card-text': textColor,
          height,
          width,
          top,
          left,
        } as React.CSSProperties
      }
    >
      <div className={styles.title}>{card.subject?.shortName}</div>
    </div>
  );
};
PreviewGridCard.displayName = 'PreviewGridCard';
